const env = (window as any).env;

export const CONFIG = {
  apiKey: env.DHS_API_KEY,
  dhsAPI: env.DHS_API_URL,
  base_url: 'https://s3.amazonaws.com/' + env.S3_BUCKET + '/' + env.MODELED_SURFACES_S3_PATH,
  imageUrl: 'https://s3.amazonaws.com/' + env.S3_BUCKET + '/' + env.MODELED_SURFACES_S3_PATH,
  packageUrl: 'https://s3.amazonaws.com/' + env.S3_BUCKET + '/' + env.MODELED_SURFACES_S3_PATH,
  packageVersion: 'v01',
};

export const URL_CONFIG = 'https://dhs-sites.s3.amazonaws.com/SDR/modeled-surfaces';
export const S3_SUB_BUCKET_PATH = env.APP_ENV === 'dev' ? 'test' : 'production';
